import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "View"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M512 160q242.016 22.016 376 176T1024 512q-2.016 22.016-136 176T512 864q-242.016-22.016-376-176T0 512q2.016-22.016 136-176T512 160z m0 64q-170.016 11.008-283.008 114.496T74.976 512q40.992 70.016 154.016 173.504T512 800q170.016-11.008 283.008-114.496T949.024 512q-40.992-70.016-154.016-173.504T512 224z m0 64q95.008 2.016 158.496 65.504T736 512q-2.016 95.008-65.504 158.496T512 736q-95.008-2.016-158.496-65.504T288 512q2.016-95.008 65.504-158.496T512 288z m0 64q-68 2.016-112.992 47.008T352 512q2.016 68 47.008 112.992T512 672q68-2.016 112.992-47.008T672 512q-2.016-68-47.008-112.992T512 352z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var view = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\view.vue"]]);

export { view as default };
